import { render } from "./MBackAlley.vue?vue&type=template&id=6188665e&scoped=true"
import script from "./MBackAlley.vue?vue&type=script&lang=js"
export * from "./MBackAlley.vue?vue&type=script&lang=js"

import "./MBackAlley.vue?vue&type=style&index=0&id=6188665e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6188665e"]])

export default __exports__